import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { BaseApiService } from './base-api.service';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { SimpleLimits, City, Zone } from './../models/index';

@Injectable()
export class SimpleLimitsService extends BaseApiService implements Resolve<SimpleLimits> {
  constructor(
    private apiCallService: ApiCallService
  ) {
    super();
  }

  getSimpleLimits(): Promise<SimpleLimits> {
    return this.apiCallService.get('/new_properties/simple_limits');
  }

  resolve(route: ActivatedRouteSnapshot): Promise<SimpleLimits> {
    const promise = this.getSimpleLimits();
    return promise;
  }

  ng2SelectItems(cities: City[]): any[] {
    return cities.map((city: City) => {
      return {
        text: city.name,
        children: city.zones.map((zone: Zone) => {
          return {
            id: zone.id,
            text: zone.name
          };
        })
      };
    });
  }

  ng2SelectedItems(cities: City[], zoneId: number[]): any[] {
    for (const cityIndex in cities) {
      if (cities.hasOwnProperty(cityIndex)) {
        for (const zoneIndex in cities[cityIndex].zones) {
          if (cities[cityIndex].zones.hasOwnProperty(zoneIndex) && +zoneId === +cities[cityIndex].zones[zoneIndex]['id']) {
            return [{ id: cities[cityIndex].zones[zoneIndex]['id'], text: cities[cityIndex].zones[zoneIndex]['name'] }];
          }
        }
      }
    }
    return null;
  }

  ngSelectItems(cities: City[]): any[] {
    const array = [];

    cities.forEach(city => {
      city.zones.forEach(zone => {
        array.push({
          id: zone.id,
          name: zone.name,
          city: city.name
        })
      });
    });

    return array;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/simple-limits.service.ts